module.exports = __webpack_public_path__ + "img/development-during-recession-top.4c6f6ac0.jpeg";